import React from 'react';
import { TrendingUp, CheckCircle, Handshake } from 'lucide-react';
import { Button } from './ui/button';

const InvestmentOptions = () => {
  const options = [
    {
      icon: TrendingUp,
      title: "Invest Over Time",
      description: "Tailored investment plans that fit your financial timeline"
    },
    {
      icon: CheckCircle,
      title: "Investor Loans",
      description: "Financing options to help you meet the necessary investment requirements."
    },
    {
      icon: Handshake,
      title: "Free Consultation",
      description: "Speak with our experts to understand your options and the process."
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-[#1a3a5c] text-2xl md:text-3xl font-bold text-center mb-12 uppercase">
          Explore Flexible Investment Options
        </h2>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {options.map((option, index) => {
            const IconComponent = option.icon;
            return (
              <div key={index} className="text-center">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                  <IconComponent className="w-12 h-12 text-[#c94a4a]" strokeWidth={1.5} />
                </div>
                <h3 className="text-[#c94a4a] text-xl font-bold mb-2">
                  {option.title}
                </h3>
                <p className="text-gray-600 text-sm">
                  {option.description}
                </p>
              </div>
            );
          })}
        </div>

        <div className="text-center">
          <Button
            onClick={() => document.getElementById('hero-form')?.scrollIntoView({ behavior: 'smooth' })}
            variant="outline"
            className="border-[#1a3a5c] text-[#1a3a5c] hover:bg-[#1a3a5c] hover:text-white px-8 py-3 rounded font-medium"
          >
            Talk To An Expert
          </Button>
        </div>
      </div>
    </section>
  );
};

export default InvestmentOptions;
